import { INewPipeLineTab } from "./interface"

export const newPipeLineTypes = {
  textDisplay: "textDisplay",
  dropDownWithBools: "dropDownWithBools",
  dropDownWithFileTypes: "dropDownWithFileTypes",
  textInput: "textInput",
  inputWithDate: "inputWithDate",
}
export const NewPipeLineTabs: INewPipeLineTab[] = [
  {
    key: "RAW Config & Quality Config",
    label: "RAW Config & Quality Config",
  },
  {
    key: "Flexible Schema Config",
    label: "Flexible Schema Config",
  },
  {
    key: "RAW Data Drift Config",
    label: "RAW Data Drift Config",
  },
  {
    key: "ADM Config",
    label: "ADM Config",
  },
  {
    key: "Model Config",
    label: "Model Config",
  },
]
export const PIPELINE_PARAMETERS_CONFIG = [
  {
    key: "Parameters",
    label: "Parameters",
  },
  {
    key: "Config",
    label: "Config",
  },
]

export const NEW_PIPELINE_CONFIG: any = {
  "RAW Config & Quality Config": [
    {
      key: "table_name",
      type: newPipeLineTypes.textDisplay,
      label: "Table Name",
    },
    {
      key: "recreate",
      type: newPipeLineTypes.dropDownWithBools,
      label: "Recreate",
    },
    {
      key: "profiling_required",
      type: newPipeLineTypes.dropDownWithBools,
      label: "Profiling",
    },
    { key: "location", type: newPipeLineTypes.textInput, label: "Location" },
    {
      key: "special_char",
      type: newPipeLineTypes.dropDownWithBools,
      label: "Special Character",
    },
    {
      key: "file_format",
      type: newPipeLineTypes.dropDownWithFileTypes,
      label: "File Format",
    },
  ],
  "RAW Data Drift Config": [
    {
      key: "table_name",
      type: newPipeLineTypes.textDisplay,
      label: "Table Name",
    },
    {
      key: "column_name",
      type: newPipeLineTypes.textInput,
      label: "Column",
    },
    {
      key: "drift_check_required",
      type: newPipeLineTypes.dropDownWithBools,
      label: "Drift Check Required",
    },
    {
      key: "aggregation_year_column",
      type: newPipeLineTypes.textInput,
      label: "Aggregation Year",
    },
    {
      key: "aggregation_month_column",
      type: newPipeLineTypes.textInput,
      label: "Aggregation Month",
    },
    {
      key: "soft_threshold_upper_limit",
      type: newPipeLineTypes.textInput,
      label: "Soft Thresh Hold Upper Limit",
    },
    {
      key: "soft_threshold_lower_limit",
      type: newPipeLineTypes.textInput,
      label: "Soft Thresh Hold Lower Limit",
    },
    {
      key: "hard_threshold_upper_limit",
      type: newPipeLineTypes.textInput,
      label: "Hard Thresh Hold Upper Limit",
    },
    {
      key: "hard_threshold_lower_limit",
      type: newPipeLineTypes.textInput,
      label: "Hard Thresh Hold Lower Limit",
    },
  ],
  "ADM Config": [
    {
      key: "table_name",
      type: newPipeLineTypes.textDisplay,
      label: "Table Name",
    },
    {
      key: "recreate",
      type: newPipeLineTypes.dropDownWithBools,
      label: "Recreate",
    },
  ],
  "Flexible Schema Config": [
    {
      key: "table_name",
      type: newPipeLineTypes.textDisplay,
      label: "Table Name",
    },
    {
      key: "pipeline_column_name",
      type: newPipeLineTypes.textInput,
      label: "Pipeline Column Name",
    },
    {
      key: "warehouse_column_name",
      type: newPipeLineTypes.textInput,
      label: "Warehouse Column Name",
    },
    {
      key: "data_type",
      type: newPipeLineTypes.textInput,
      label: "Data Type",
    },
  ],
  "Model Config": [
    {
      key: "CHANNEL",
      type: newPipeLineTypes.textInput,
      label: "Channel",
    },
    {
      key: "CHANNEL_MAPPED",
      type: newPipeLineTypes.textInput,
      label: "Channel Mapped",
    },
    // {
    //   key: "START_YEAR_MONTH",
    //   type: newPipeLineTypes.inputWithDate,
    //   label: "Start Year Month",
    // },
    // {
    //   key: "END_YEAR_MONTH",
    //   type: newPipeLineTypes.inputWithDate,
    //   label: "End Year Month",
    // },
    {
      key: "FLAG",
      type: newPipeLineTypes.dropDownWithBools,
      label: "Flag",
    },
  ],
  Parameters: [
    {
      key: "param_name",
      type: newPipeLineTypes.textDisplay,
      label: "Parameter Name",
    },
    {
      key: "type",
      type: newPipeLineTypes.textDisplay,
      label: "Type",
    },
    {
      key: "default_value",
      type: "dynamicCell",
      label: "Value",
    },
  ],
}

export const newPipeLineMapper: any = {
  // "Modify/Preview Config": "RAW",
  "RAW Config & Quality Config": "RAW",
  "UDM Config": "UDM",
  "ADM Config": "ADM",
  "RDQ Config": "RDQ",
  "Input Series Config": "INPS",
  "RAW Data Drift Config": "RDDC",
  "Flexible Schema Config": "FSC",
  "Model Config": "MC",
  Parameters: "PARAMS",
}

export enum NEW_PIPELINE_SCREENS {
  DETAILS = "Details",
  PARAMETERS = "Parameters",
  CONFIG = "Config",
  SCHEDULE = "Schedule",
}

export const screenWiseConfig: any = {
  title: {
    [NEW_PIPELINE_SCREENS.DETAILS]: "Select Pipeline to Run",
    [NEW_PIPELINE_SCREENS.PARAMETERS]: "",
    [NEW_PIPELINE_SCREENS.CONFIG]: "",
    [NEW_PIPELINE_SCREENS.SCHEDULE]: "Schedule the Run",
  },
  btn: {
    [NEW_PIPELINE_SCREENS.CONFIG]: "Next",
    [NEW_PIPELINE_SCREENS.DETAILS]: "Next",
    [NEW_PIPELINE_SCREENS.SCHEDULE]: "Run & Submit",
    [NEW_PIPELINE_SCREENS.PARAMETERS]: "Next",
  },
}
